module.exports = __webpack_public_path__ + "img/電気回路_5_6_5.dbbad577.png";